import { render, staticRenderFns } from "./mb_list.vue?vue&type=template&id=1a56f5eb&scoped=true&"
import script from "./mb_list.vue?vue&type=script&lang=js&"
export * from "./mb_list.vue?vue&type=script&lang=js&"
import style0 from "./mb_list.vue?vue&type=style&index=0&id=1a56f5eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56f5eb",
  null
  
)

export default component.exports